import { CLIENT_TYPES } from 'config/const';
import { getMobileNumber } from 'utils/method';
import { callFetch, header } from './utils';

const EndPoint = {
  SendSms: () => `/line/sms-code`,
  verifySms: () => `/line/sms-verify`,
};

export function sendSms(phoneNumber) {
  const uri = EndPoint.SendSms();
  let settings = {
    method: 'POST',
    headers: { ...header },
    body: JSON.stringify({
      type: CLIENT_TYPES.CLIENT,
      phoneNumber: getMobileNumber(phoneNumber),
      options: {
        hasCharacter: false,
        length: 4,
        verifyCodeMessage:
          '您好\n您的行動電話 OTP 驗證碼為「{{code}}」，請立即在欄位輸入，完成驗證作業。',
      },
    }),
  };

  return callFetch(uri, settings);
}
export function verifySms(phoneNumber, lineId, verifyCode) {
  const uri = EndPoint.verifySms();
  let settings = {
    method: 'POST',
    headers: { ...header },
    body: JSON.stringify({
      type: CLIENT_TYPES.CLIENT,
      phoneNumber: getMobileNumber(phoneNumber),
      lineId,
      verifyCode,
    }),
  };

  return callFetch(uri, settings);
}
